export default
{
    watch:
    {
        monthDate( value )
        {
            if( this.currentMonthDate.getTime() !== value.getTime() )
            {
                this.changeMonthDate( value, false );
            }
        }
    }
}
